export default __webpack_public_path__ + "static/media/tree23.8ad82546.png";